import type {
  SignatureInputSkin,
  TypeOrDrawSignatureInputUiType,
} from '../SignatureInput.types';

export const calculatePenColor = (penColor?: string) => penColor || 'black';

// size of the drawn signature varies according mouse speed
// the penWidth represents the maximal width of the drawn
// signature line
export const transformPenSizeToWidths = (
  penWidth?: string,
): {
  minWidth: number;
  maxWidth: number;
} => {
  const maxWidth = penWidth && +penWidth ? +penWidth : 2.5;
  return {
    minWidth: Math.max(maxWidth / 5, 0.5),
    maxWidth,
  };
};

const typeOrDrawSkins: Array<TypeOrDrawSignatureInputUiType> = [
  'TypeOrDrawSignatureInput',
];

export const isTypeOrDrawSkin = (skin: SignatureInputSkin) => {
  const skinSuffix = skin.split('.').pop();
  return (
    typeOrDrawSkins.includes(skin as TypeOrDrawSignatureInputUiType) ||
    typeOrDrawSkins.includes(skinSuffix as TypeOrDrawSignatureInputUiType)
  );
};
